export { default as Loader } from './Loader'